//正式环境
export const metricUrl = process.env.NODE_ENV === 'development'?"http://localhost:10035":"https://mall-metric-exporters.baicizhan.com";
export const adminUrl = process.env.NODE_ENV === 'development'?"http://localhost:10040":"https://mall-alert-system-admin.baicizhan.com";
export const prometheusUrl = process.env.NODE_ENV === 'development'?"http://localhost:9090":"http://mall-prometheus-server.cya-inner-service-prod.vpc";
export const loginCheckUrl = process.env.NODE_ENV === 'development'?"http%3A%2F%2Flocalhost%3A3001%2F%23%2Flogin":"https%3A%2F%2Fmall-alert-face.baicizhan.com%2F%23%2Flogin";
export const frontUrl = process.env.NODE_ENV === 'development'?"http://localhost:3001":"https://mall-alert-face.baicizhan.com";
//测试环境
// export const metricUrl = "https://mall-mtrc-exptrs-test.baicizhan.com";
// export const adminUrl = "https://mall-alt-sys-adm-test.baicizhan.com";
// export const prometheusUrl = "http://mall-prom-svr-test.cya-inner-service-test.vpc";
// export const loginCheckUrl = "https%3A%2F%2Fmall-alert-face-test.baicizhan.com%2F%23%2Flogin";
// export const frontUrl = "https://mall-alert-face-test.baicizhan.com";


// WEBPACK FOOTER //
// ./src/utils/GetUrl.js